module.exports = __webpack_public_path__ + "images/landing/banner/business.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/banner/business.png
// module id = HnXD
// module chunks = 153